import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store/store';
import bus from '@/bus';
import '@/assets/css/styles.css';
import '@/validations/vee-validate';
import * as VueGoogleMaps from "vue2-google-maps";
import '@fortawesome/fontawesome-free/css/all.css';
// Import Swiper styles
import '../node_modules/swiper/swiper-bundle.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
//import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag";
var VueScrollTo = require('vue-scrollto');
import IdleVue from 'idle-vue';
import * as _ from 'lodash'
import VueMeta from 'vue-meta'
Vue.prototype._ = _ 

import NormalApis from '@/Components/Controllers/NormalApis';
import AuthApis from '@/Components/Controllers/AuthApis';
import Env from '@/env';
import PubNub from 'pubnub';

window.pubnub = new PubNub({
  subscribeKey: Env.pubnubSubscribeKey,
  publishKey: Env.pubnubPublishKey,
  secretKey: "",
  uuid: 'budler_web_app',
  presenceTimeout : 600, // 10 minutes
  keepAlive : true,
  keepAliveSettings: {
    keepAliveMsecs: 300000, //5mins  10000, // 10 seconds
  },
})

// console.log(process.env.NODE_ENV)

/**
 * Google Oauth 2
 */
 import GAuth from 'vue-google-oauth2'
 const gauthOption = {
   clientId: Env.googleAuthClientId,//'719611597738-rdc330vj8p3pb1cn823vjjlplv7vpcpi.apps.googleusercontent.com',
   scope: 'profile email',
   prompt: 'select_account'
 }

 // '845709380136-8pr7jvibbdce1s7bd0t294v9rcfgp92s.apps.googleusercontent.com',
 Vue.use(GAuth, gauthOption)
 Vue.use(VueMeta)
/**
 * Make Apis Available Globally
 */
const allApis = { ...NormalApis, ...AuthApis }
Vue.mixin({
    methods: allApis,
});
Vue.use(VueScrollTo);

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000, // 1000 is 1 second, this is 5minutes
})

/// Checking if production - if so add analytics
const hostname = window.location.hostname
const localhost = hostname === 'localhost';
const env = (function () {
    if (localhost) return 'development'
    if (hostname.includes('dev')) return 'development'
    if (hostname.includes('.uat.')) return 'uat'
    if (hostname.includes('beta')) return 'beta'
    return 'production'
}())



if (env === 'production') {
  console.log('@production - tracking analytics')
  Vue.use(VueGtag, {
    config: { id: "G-RDJX55RE7W" } 
  }, router);
  !(function(a, e) {
    if (!a.aap) {
      a.aap = function(e) {
      ;(a.acuityAdsEventQueue = a.acuityAdsEventQueue || []).push(e)
    }
    var t = 'script'
    var i = e.createElement(t)
    i.async = true
    i.src = 'https://origin.acuityplatform.com/event/v2/pixel.js'
    var c = e.getElementsByTagName(t)[0]
    c.parentNode.insertBefore(i, c)
    a.acuityPiggybackCallback = function(e) {
      a.acuityParseResponse(e)
    }
    }
  })(window, document)
  aap({ pixelKey: '4844551339206571729' })

} else {

  console.log('@uat @beta @dev - tracking analytics, clarity');

  (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  }(window, document, "clarity", "script", "fn26z1h85q"));

  Vue.use(VueGtag, {
    config: { id: "UA-164667407-2" } // mine local UA-83860158-1
  }, router);


}

 /**
  * Vbout script
  */
if (env === 'development') {
    /* embed code starts */
    var _vbset = _vbset || [];
    _vbset.push(['_account', Env.vbout.domain]);
    _vbset.push(['_domain', Env.vbout.domain_url]);

    (function() {
      var vbt = document.createElement('script'); vbt.type = 'text/javascript'; vbt.async = true; 
      vbt.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.vbt.io/tracker?_account='+_vbset[0][1]+'&_domain='+_vbset[1][1];var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vbt, s);
    })();
    /* embed code ends */
} else if(env == 'beta') {
  /* embed code starts */
  var _vbset = _vbset || [];
  _vbset.push(['_account', Env.vbout.domain]);
  _vbset.push(['_domain', Env.vbout.domain_url]);

  (function() {
    var vbt = document.createElement('script'); vbt.type = 'text/javascript'; vbt.async = true; 
    vbt.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.vbt.io/tracker?_account='+_vbset[0][1]+'&_domain='+_vbset[1][1];var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vbt, s);
  })();
  /* embed code ends */
}  else if(env == 'uat') {
  /* embed code starts */
  var _vbset = _vbset || [];
  _vbset.push(['_account', Env.vbout.domain]);
  _vbset.push(['_domain', Env.vbout.domain_url]);

  (function() {
    var vbt = document.createElement('script'); vbt.type = 'text/javascript'; vbt.async = true; 
    vbt.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.vbt.io/tracker?_account='+_vbset[0][1]+'&_domain='+_vbset[1][1];var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vbt, s);
  })();
  /* embed code ends */
} else {
  // this is for prod
}

window.bus = bus;

Vue.use(VueGoogleMaps, {
    load: {
      key: Env.googleMapKey,
      libraries: "places"
    }
});


/**
 * Impliment middleware
 */
// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    // If no subsequent Middleware exists,
    // the default `next()` callback is returned.
    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);
        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}

router.beforeEach((to, from, next) => {
    store.commit('MUTATE_CURRENT_ROUTE', {
      name: to.name,
      params: to.params,
      query: to.query,
    });
    if(store.getters.getLandingRoute == ''){
      // If landing route is blank set landing route, if the landing first route is not age verification or tokenlogin page
      if(to.name != 'VisitorAgeVerification' && to.name != 'LoginWithToken'){
        store.dispatch('SET_LANDING_ROUTE', to.fullPath)
      }
    }
    // remove unnecessary query from route

    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ?
            to.meta.middleware : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };

        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
});

window._$store = store;
new Vue({
    router,
    store: window === window.top ? window._$store : window.parent._$store,
    render: h => h(App)
}).$mount('#app')